import {
  IAddress,
  IAddressAutocomplete,
  ICountryAutocomplete,
  IRemoveAddressPayload,
  ISaveAddressPayload,
  IStateAutocomplete,
} from 'addresses/types';
import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const getManyAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IAddressAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/addresses/address/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IAddressAutocomplete>(data.addresses, data.total_count);
};

export const getCountriesAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<ICountryAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/addresses/country/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<ICountryAutocomplete>(data.countries, data.total_count);
};

export const getStatesAutocomplete = async (
  requestPayload: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IStateAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/addresses/state/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<IStateAutocomplete>(data.states, data.total_count);
};

export const removeAddress = async (data: IRemoveAddressPayload) => {
  return partfinitiClient.postForm('/addresses/index/remove', data);
};

export const saveAddress = async (data: ISaveAddressPayload): Promise<IAddress> => {
  const response = await partfinitiClient.postForm('/addresses/index/save', data, {
    includeNullValues: true,
  });

  return response?.address;
};
